import { ActiveStorageAttachment } from "./activeStorageAttachment";

export interface LocationInformationOptions {
  buildingAccessHoursOptions: Record<string, string>;
  coiRequiredOptions: Record<string, string>;
  freightElevatorNotesOptions: Record<string, string>;
  loadingDockHeightOptions: Record<string, string>;
  loadingZoneOptions: Record<string, string>;
  timeLimitLoadingZoneMinutesOptions: Record<string, string>;
}

export interface LocationInformation {
  locationUuid?: string;
  buildingAccessHoursOption: string | null;
  coiRequiredOption: string | null;
  freightElevatorNotesOption: string | null;
  buildingProtectionNotes: string | null;
  unionLaborRequired: boolean;
  passengerElevatorAvailable: boolean;
  buildingCartsAvailable: boolean;
  specialAccessNotes: string | null;
  loadingDockHeightOption: string | null;
  loadingZoneOption: string | null;
  timeLimitLoadingZoneMinutes: number | null;
  dockDoorDimensions: string | null;
  semiTruckAccess: boolean;
  boxTruckAccess: boolean;
  dockTruckNotes: string | null;
  certificateOfInsuranceFile?: ActiveStorageAttachment | string | null;
  updatedAt?: string | null;
  lastUpdatedByName?: string | null;
}

export const DEFAULT_LOCATION_INFORMATION: LocationInformation = {
  buildingAccessHoursOption: null,
  coiRequiredOption: null,
  freightElevatorNotesOption: null,
  buildingProtectionNotes: null,
  unionLaborRequired: false,
  passengerElevatorAvailable: true,
  buildingCartsAvailable: false,
  specialAccessNotes: "",
  loadingDockHeightOption: null,
  loadingZoneOption: null,
  timeLimitLoadingZoneMinutes: null,
  dockDoorDimensions: "",
  semiTruckAccess: false,
  boxTruckAccess: true,
  dockTruckNotes: "",
};
